import React from 'react';
import {ModalIds} from '@common/models/enums/modal-ids.enum';
import SpecialistForm from './specialist-form';
import useModalWithData from "@common/hooks/use-modal-with-data";
import AppModal from "../../core/components/app-modal";
import {useModalAnimation} from "../../core/animations";
import {animated} from "@react-spring/web";
import {UniversalClickHandler} from "@common/models/types/universal-click-handler.type";

export interface SpecialistFormModalData {
    specialistId?: string;
    onSuccess?: UniversalClickHandler;
}

const SpecialistFormModal: React.FC = () => {
    const {data, hideModal, isOpenModal} = useModalWithData<SpecialistFormModalData>(ModalIds.SPECIALIST_FORM);

    const {springProps, closeModal} = useModalAnimation(!!isOpenModal(), 'medium');

    const handleCancel = () => {
        closeModal(() => {
            hideModal()
        });
    };

    const isEdit = !!data?.specialistId;

    return (
        <AppModal
            id={ModalIds.SPECIALIST_FORM}
            key={ModalIds.SPECIALIST_FORM}
            zIndex={40}
            forceFixed={true}
            classModal="flex justify-center"
        >
            <animated.div
                style={springProps}
                className="h-full w-full flex flex-col bg-[#F9FAFB] rounded-2xl md:min-w-[640px] max-h-[85svh] md:max-h-[80vh]"
            >
                <div className="flex items-center justify-between pl-8 pr-4 py-3 h-[72px] max-h-[72px]">
                    <h2 className="text-lg font-semibold text-on-surface leading-[22px]">
                        {isEdit ? 'Edytuj profil specjalisty' : 'Dodaj specjalistę'}
                    </h2>
                </div>

                <div className="px-8 w-full overflow-y-auto">
                    <SpecialistForm
                        specialistId={data?.specialistId}
                        onSuccess={data?.onSuccess}
                        onCancel={handleCancel}/>
                </div>
            </animated.div>
        </AppModal>
    );
};

export default SpecialistFormModal;

